import t from 'tcomb';

const Password = t.subtype(t.Str, function(x) {
  return x.length >= 6;
});

module.exports = Password;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Password.js
 **/